import React, { useContext } from 'react';

import { Circle } from 'rc-progress';

import TenantConfig from '../../config';
import { UserContext } from '../../context/UserContext';

const Stepper = ({ sections, activeIndex, completed, handleChangeSectionIndex, isClickable }) => {
  const { width } = useContext(UserContext);

  let stepperSections = sections;
  if (stepperSections.length === 2 && stepperSections[0] === 'documents') {
    stepperSections = [stepperSections[0]];
  }

  const handleClick = (index) => {
    if (process.env.REACT_APP_USE_MOCK === 'true' || isClickable) {
      handleChangeSectionIndex(index);
    }
  };
  return width > 1200 ? (
    <div className={TenantConfig?.stepper.mainClassName}>
      {stepperSections.map((section, index) => (
        <div
          className={`step-item ${
            index === activeIndex.sectionIndex || index <= completed ? 'active' : ''
          }`}
          key={'step' + index}
          onClick={() => handleClick(index)}
        >
          <p>{section}</p>
          <div className="step-border" />
        </div>
      ))}
    </div>
  ) : (
    <div className="mobile-stepper">
      <div className="step-index">
        <Circle
          className="mobile-circle"
          percent={(activeIndex.sectionIndex / stepperSections.length) * 100}
          trailWidth="3"
          strokeWidth="3"
          strokeColor="#462D7A"
        />
        <span>
          {activeIndex.sectionIndex + 1} of {stepperSections.length}
        </span>
      </div>
      <h3>{stepperSections[activeIndex.sectionIndex]}</h3>
    </div>
  );
};

export default Stepper;
